import React from "react";
import { Tag } from "antd";
import { TAG_CONFIG, INFO_MESSAGES } from "../../constants/adminBookingConstants";

/**
 * Priority Tag Component
 * Displays a priority tag (Priority/Normal) with appropriate styling
 * 
 * When Round Robin mode is enabled, priority tags are hidden since priority
 * is not used in Round Robin distribution.
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isHighPriority - Whether the admin has high priority
 * @param {boolean} props.roundRobinEnabled - Whether Round Robin mode is enabled
 * @param {string} [props.className] - Additional CSS classes
 */
const PriorityTag = ({ isHighPriority, roundRobinEnabled, className = "" }) => {
  // Don't show priority tags when Round Robin is enabled (priority is ignored)
  if (roundRobinEnabled) {
    return null;
  }

  return (
    <div
      className={className}
      style={{
        minWidth: `${TAG_CONFIG.MIN_WIDTH}px`,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      {isHighPriority ? (
        <Tag color="gold" style={{ margin: 0, fontWeight: 600 }}>
          ⭐ Priority
        </Tag>
      ) : (
        <Tag color="default" style={{ margin: 0, opacity: 0.6 }}>
          Normal
        </Tag>
      )}
    </div>
  );
};

export default PriorityTag;
